// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    secretId: z.string().min(1).max(21),
    ssoConnectorId: z.string().min(1).max(128),
    issuer: z.string().min(1).max(256),
    identityId: z.string().min(1).max(128),
});
const guard = z.object({
    tenantId: z.string().max(21),
    secretId: z.string().min(1).max(21),
    ssoConnectorId: z.string().min(1).max(128),
    issuer: z.string().min(1).max(256),
    identityId: z.string().min(1).max(128),
});
export const SecretEnterpriseSsoConnectorRelations = Object.freeze({
    table: 'secret_enterprise_sso_connector_relations',
    tableSingular: 'secret_enterprise_sso_connector_relation',
    fields: {
        tenantId: 'tenant_id',
        secretId: 'secret_id',
        ssoConnectorId: 'sso_connector_id',
        issuer: 'issuer',
        identityId: 'identity_id',
    },
    fieldKeys: [
        'tenantId',
        'secretId',
        'ssoConnectorId',
        'issuer',
        'identityId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
